"use client"
import { useRouter, usePathname } from 'next/navigation';
import React, { useCallback } from 'react'
import SelectDefault from '../../../blocks/forms/SelectDefault';
import { REGION } from '../../../../data/constants';
import { translateIt } from '../../../../data/translations';
import { SectorAPI } from '../../../../data/market';

import ECSearch from './ECSearch';
import { createQueryString } from '@/library/utils/urlParams';


export default function ECFilter(props) {
  const {
    searchParams,
    countryId,
  } = props;
  
  const router = useRouter();
  const pathname = usePathname()


  const handleOnChange = (e) => {
    const name = e.target.name
    const value = e.target.value
    const url = `${pathname}?${createQueryString(name, value, searchParams)}`
    router.push(url)
  }

  let sectorList = SectorAPI.getListByCountryId(countryId)
  const initialValue = {
    sector: searchParams.instrument_sector_identifier || sectorList[0].value,
    query: searchParams.query || ''
  }

  return (
    <div className="grid grid-cols-1 gap-4 p-2">
      <div className="relative">
        <ECSearch placeholder={translateIt(countryId, 'search')} onChange={handleOnChange} />
      </div>
      <SelectDefault
        list={sectorList}
        onChange={handleOnChange}
        label={translateIt(countryId, 'sector')}
        name="instrument_sector_identifier"
        defaultSelectedKey={[initialValue.sector]}
      />
    </div>
  )
}
